/* eslint-disable no-unused-vars */
import React from "react";
import { useFormatMessage as t } from '../../i18n/translate';
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
// core components
import AdminNavbarLinks from "./AdminNavbarLinks.js";
import RTLNavbarLinks from "./RTLNavbarLinks.js";
import Button from "../../components/CustomButtons/Button.js";

import styles from "../../assets/jss/material-dashboard-react/components/headerStyle.js";
import { connect } from "react-redux";

const useStyles = makeStyles(styles);

function Header(props) {
  const classes = useStyles();
  function makeBrand() {
    var name;
    props.routes.map(prop => {
      if (prop.parent) {
        let lasturl = window.location.href.split('/').pop();
        let routeElem = prop.nestedRoutes.find(elem => elem.path == ('/' + lasturl));
        if (routeElem) {
          let projectName = props.actualProject?.title ? props.actualProject?.title : ""
          name = routeElem?.navBarName + ' ' + projectName;
          return
        }
      }
      let menuName = prop.navBarName ? t(prop.navBarName) : 'test'
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        let projectName = props.actualProject?.title ? props.actualProject?.title : ""
        name = props.rtlActive ? prop.rtlName : menuName + ' ' + projectName;
      }
      return null;

    });
    return name;
  }
  const { color } = props;
  const appBarClasses = classNames({
    [" " + classes[color]]: color
  });
  return (
    <AppBar
      // style={{ background: 'white', padding: '0.25rem', border: '1px solid', borderRadius: '1rem' }}
      className={classes.appBar + appBarClasses}
    >
      <Toolbar className={classes.container}>
        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name */}
          <Button color="transparent" href="#" className={classes.title}>
            {makeBrand()}
          </Button>
        </div>
        <Hidden smDown implementation="css">
          {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
        </Hidden>
        <Hidden mdUp implementation="css">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object)
};


const mapStateToProps = (state) => {
  return {
    _id: state.authReducer.user._id,
    actualProject: state.projectReducer?.project
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
